import React from 'react'
import SliderOurClients from '../../component/SliderOurClients'

const OurClients = () => {
    return (
        <>

            <div className="section-client-slider" style={{ marginTop: "50px" }}>
                <div className="space-x-128">
                    <div className="client-slider-style-1">
                        <div className="container-fluid">
                            <div className="row align-items-center">
                                <div className="col-xl-3 col-xxl-2">
                                    <h4 className="mb-4 mb-xl-0">Our Valuable Clients</h4>
                                </div>
                                <div className="col-xl-9 col-xxl-10">
                                    <div className="client-one swiper swiper-initialized swiper-horizontal">
                                        <div className="swiper-wrapper align-items-center" id="swiper-wrapper-7de3a766687d944d" aria-live="off" style={{ transitionDuration: '3000ms', transform: 'translate3d(0px, 0px, 0px)' }}>
                                            <SliderOurClients />
                                        </div>
                                        <span className="swiper-notification" aria-live="assertive" aria-atomic="true" /></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default OurClients